/**
 * Build a CSS `url()` token that is safe for any asset URL.
 *
 * This exists because of a real bug: Vite inlines small SVGs as data URIs and
 * writes the markup's attributes with single quotes (`class='lucide ...'`). CSS
 * forbids quote characters inside an *unquoted* url() token, so
 * `url(data:image/svg+xml,...class='lucide'...)` is invalid -- the browser drops
 * the whole declaration. Every masked icon silently vanished.
 *
 * Quoting the URL fixes it. Double quotes inside are percent-encoded so they
 * cannot terminate the string early.
 */
export function cssUrl(raw: string): string {
  return `url("${raw.replace(/"/g, "%22")}")`;
}
